import { createSignal, For, Show } from 'solid-js'
import { events, resetEvents, setEvents } from '~/stores/events'

function isoToDatetimeLocal(iso: string): string {
  const d = new Date(iso)
  const pad = (n: number) => n.toString().padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function Devtools() {
  const [open, setOpen] = createSignal(false)

  return (
    <div class="fixed bottom-3 right-3 z-50 flex flex-col items-end gap-2">
      <Show when={open()}>
        <div class="max-h-[70vh] w-80 overflow-y-auto rounded-lg border border-gray-200 bg-white p-3 shadow-xl">
          <div class="mb-3 flex items-center justify-between">
            <span class="text-sm font-semibold text-gray-700">
              Event Devtools
            </span>
            <button
              class="cursor-pointer text-xs text-blue-500 hover:text-blue-700"
              onClick={resetEvents}
            >
              Reset
            </button>
          </div>

          <For each={events}>
            {(event, idx) => (
              <div class="mb-3 last:mb-0">
                <p class="mb-1 text-xs font-medium text-gray-500">{event.id}</p>
                <DateField
                  label="Start"
                  value={event.validStartDate}
                  onChange={(v) => setEvents(idx(), 'validStartDate', v)}
                />
                <DateField
                  label="End"
                  value={event.validEndDate}
                  onChange={(v) => setEvents(idx(), 'validEndDate', v)}
                />
                <DateField
                  label="Visible end"
                  value={event.visibleEndDate}
                  onChange={(v) => setEvents(idx(), 'visibleEndDate', v)}
                />
              </div>
            )}
          </For>
        </div>
      </Show>

      <button
        class="flex size-10 cursor-pointer items-center justify-center rounded-full bg-gray-800 text-lg text-white shadow-lg hover:bg-gray-700"
        onClick={() => setOpen((v) => !v)}
        title="Toggle devtools"
      >
        {open() ? '\u00D7' : '\u2699'}
      </button>
    </div>
  )
}

function DateField(props: {
  label: string
  value: string
  onChange: (value: string) => void
}) {
  return (
    <label class="mb-1 flex items-center gap-2 last:mb-0">
      <span class="w-16 shrink-0 text-[11px] text-gray-400">{props.label}</span>
      <input
        type="datetime-local"
        class="min-w-0 flex-1 rounded border border-gray-300 px-1.5 py-0.5 text-xs text-gray-700"
        value={isoToDatetimeLocal(props.value)}
        onChange={(e) => {
          const val = e.currentTarget.value
          if (val) props.onChange(new Date(val).toISOString())
        }}
      />
    </label>
  )
}
